import {
    CLIENT_LAUNCHER_SET_TOKEN,
    CLIENT_LAUNCHER_SET_EULA,
    CLIENT_LAUNCHER_RESET,
} from '../constants'

export function setClientLauncherToken(serverId, userId, profile, token) {
    return {
        type: CLIENT_LAUNCHER_SET_TOKEN,
        payload: {
            serverId, userId, profile, token,
        },
    }
}

export function setClientLauncherEula(userId, eulaOk) {
    return {
        type: CLIENT_LAUNCHER_SET_EULA,
        payload: { userId, eulaOk },
    }
}

export function resetClientLauncher(userId) {
    return { type: CLIENT_LAUNCHER_RESET, payload: userId }
}



// WEBPACK FOOTER //
// ./src/actions/clientLauncher.js